(function () {
  var sectionSelector = "[data-product-section][data-section-id][data-section-type='product']";
  var optionSelector = "select[name^='options[']";
  var idAttribute = "data-option-value-id";
  var urlAttribute = "data-product-url";
  var productCache = {};
  var isRendering = false;

  function isDebug() {
    try {
      var params = new URLSearchParams(window.location.search);
      return Boolean(
        params.get("combined_listings_debug") === "true" ||
          window.localStorage.getItem("combinedListingsDebug") === "true" ||
          window.Shopify && window.Shopify.designMode
      );
    } catch (error) {
      return Boolean(window.Shopify && window.Shopify.designMode);
    }
  }

  function debug() {
    if (!isDebug()) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift("[CombinedListings]");
    console.log.apply(console, args);
  }

  function normalizePath(url) {
    try {
      var parsed = new URL(url || window.location.pathname, window.location.origin);
      return parsed.pathname.replace(/\/$/, "");
    } catch (error) {
      return "";
    }
  }

  function selectedOptions(section) {
    return Array.prototype.slice.call(section.querySelectorAll(optionSelector)).map(function (select) {
      var selected = select.options[select.selectedIndex];
      return {
        select: select,
        option: selected,
        id: selected ? selected.getAttribute(idAttribute) : "",
        productUrl: selected ? selected.getAttribute(urlAttribute) : "",
        value: selected ? selected.value : ""
      };
    });
  }

  function selectedOptionValueIds(section) {
    return selectedOptions(section).map(function (item) {
      return item.id;
    }).filter(Boolean);
  }

  function targetProductUrl(section, changedSelect) {
    var selected = selectedOptions(section);
    var currentPath = normalizePath(section.dataset.productUrl || window.location.pathname);
    var changedOption = changedSelect && changedSelect.options[changedSelect.selectedIndex];
    var changedProductUrl = changedOption && changedOption.getAttribute(urlAttribute);

    var sibling = selected.find(function (item) {
      return item.productUrl && normalizePath(item.productUrl) !== currentPath;
    });

    return sibling && sibling.productUrl || changedProductUrl || "";
  }

  function buildFetchUrl(productUrl, sectionId, optionValueIds) {
    var url = new URL(productUrl || window.location.pathname, window.location.origin);
    url.searchParams.set("section_id", sectionId);

    if (optionValueIds.length) {
      url.searchParams.set("option_values", optionValueIds.join(","));
    }

    return url;
  }

  function buildHistoryUrl(productUrl, optionValueIds) {
    var url = new URL(productUrl || window.location.pathname, window.location.origin);

    if (optionValueIds.length) {
      url.searchParams.set("option_values", optionValueIds.join(","));
    }

    return url.pathname + url.search + url.hash;
  }

  function productJsonUrl(productUrl) {
    var url = new URL(productUrl || window.location.pathname, window.location.origin);
    var path = url.pathname.replace(/\/$/, "");

    if (!/\.js$/.test(path)) {
      path += ".js";
    }

    return path + url.search;
  }

  function fetchProduct(productUrl) {
    var jsonUrl = productJsonUrl(productUrl);

    if (!productCache[jsonUrl]) {
      productCache[jsonUrl] = fetch(jsonUrl, {
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      }).then(function (response) {
        if (!response.ok) throw new Error("Product JSON fetch failed with status " + response.status);
        return response.json();
      });
    }

    return productCache[jsonUrl];
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? "," : thousands;
    decimal = decimal == null ? "." : decimal;

    if (isNaN(number) || number == null) return "0";

    var parts = (number / 100.0).toFixed(precision).split(".");
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    var cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  function formatMoney(cents, noDecimals) {
    var format = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : "${{amount}}";
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    var placeholderName = match && match[1];
    var value = "";

    if (noDecimals) {
      switch (placeholderName) {
        case "amount_with_comma_separator":
          placeholderName = "amount_no_decimals_with_comma_separator";
          break;
        case "amount_with_apostrophe_separator":
          placeholderName = "amount_no_decimals_with_apostrophe_separator";
          break;
        case "amount_with_space_separator":
          placeholderName = "amount_no_decimals_with_space_separator";
          break;
        case "amount_with_period_and_space_separator":
          placeholderName = "amount_no_decimals_with_space_separator";
          break;
        default:
          placeholderName = "amount_no_decimals";
      }
    }

    switch (placeholderName) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'", ".");
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ", ".");
        break;
      case "amount_with_period_and_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      default:
        value = formatWithDelimiters(cents, noDecimals ? 0 : 2);
    }

    return match ? format.replace(placeholder, value) : value;
  }

  function selectedProductVariant(product, variantId) {
    var variants = product && product.variants || [];
    var variant = variants.find(function (item) {
      return String(item.id) === String(variantId);
    });

    if (variant) return variant;

    return variants.find(function (item) {
      return item.available;
    }) || variants[0] || null;
  }

  function renderOptionPrice(button, variant) {
    var price = button.querySelector("[data-combined-listings-option-price]");
    if (!price || !variant) return;

    price.textContent = formatMoney(variant.price);
    price.hidden = false;

    window.requestAnimationFrame(function () {
      if (price.scrollWidth > price.clientWidth + 1) {
        price.textContent = formatMoney(variant.price, true);
      }

      button.setAttribute("aria-label", [
        button.getAttribute("data-option-value") || button.textContent.trim(),
        price.textContent
      ].filter(Boolean).join(" "));
    });
  }

  function unloadThemeSection(container) {
    var registry = window.Shopify && window.Shopify.theme && window.Shopify.theme.sections;
    if (!registry || !registry.instances) return;

    var index = registry.instances.findIndex(function (instance) {
      return instance.container === container;
    });

    if (index === -1) return;

    try {
      registry.instances[index].onUnload();
    } catch (error) {
      debug("section unload error", error);
    }

    registry.instances.splice(index, 1);
  }

  function loadThemeSection(container) {
    var registry = window.Shopify && window.Shopify.theme && window.Shopify.theme.sections;
    if (!registry || !registry.registered || !registry.instances) return;

    var type = container.getAttribute("data-section-type");
    var SectionConstructor = registry.registered[type];

    if (!SectionConstructor) return;

    try {
      registry.instances.push(new SectionConstructor(container));
    } catch (error) {
      debug("section load error", error);
    }
  }

  function refreshPaymentButtons() {
    if (window.Shopify && window.Shopify.PaymentButton) {
      try {
        window.Shopify.PaymentButton.init();
      } catch (error) {
        debug("payment button init error", error);
      }
    }
  }

  function initializeWishlistButton(section) {
    var button = section.querySelector("#wishlist-hero-product-page-button");
    var sdk = window.WishListHero_SDK || window.WishlistHero_SDK;

    if (!button || !sdk || typeof sdk.InitializeAddToWishListButton !== "function") {
      return false;
    }

    function hasWishlistButtonContent() {
      return Boolean(
        button.querySelector("#wishlisthero-product-page-button-container") ||
          button.querySelector(".wishlisthero-product-page-button-container") ||
          button.querySelector("button, a")
      );
    }

    cleanupWishlistButtons(button);

    if (hasWishlistButtonContent()) {
      button.dataset.wlhInitializedVariantId = button.dataset.wlhVariantId;
      return true;
    }

    if (button.dataset.wlhInitRequestedVariantId === button.dataset.wlhVariantId) {
      return true;
    }

    button.innerHTML = "";

    try {
      button.classList.add("wishlist-hero-custom-button");
      button.dataset.wlhInitRequestedVariantId = button.dataset.wlhVariantId;

      sdk.InitializeAddToWishListButton({
        ButtonClassElement: button.dataset.wlhButtonClassElement || "wishlist-hero-product-page-button",
        ProductId: Number(button.dataset.wlhProductId),
        ProductLink: button.dataset.wlhProductLink,
        ProductVariantId: Number(button.dataset.wlhVariantId),
        ProductPrice: Number(button.dataset.wlhProductPrice),
        ProductTitle: button.dataset.wlhProductTitle,
        ProductImage: button.dataset.wlhProductImage,
        ButtonMode: button.dataset.wlhButtonMode || "button_with_icon",
        WishlistHash: button.dataset.wlhView || "Product"
      });

      debug("wishlist button initialized", {
        productId: button.dataset.wlhProductId,
        variantId: button.dataset.wlhVariantId
      });

      window.setTimeout(function () {
        if (hasWishlistButtonContent()) {
          button.dataset.wlhInitializedVariantId = button.dataset.wlhVariantId;
        }
      }, 100);

      return true;
    } catch (error) {
      debug("wishlist button init error", error);
      return false;
    }
  }

  function wishlistProductInfo(button) {
    return {
      ProductId: Number(button.dataset.wlhProductId),
      ProductLink: button.dataset.wlhProductLink,
      ProductVariantId: Number(button.dataset.wlhVariantId),
      ProductPrice: Number(button.dataset.wlhProductPrice),
      ProductTitle: button.dataset.wlhProductTitle,
      ProductImage: button.dataset.wlhProductImage,
      WishlistHash: button.dataset.wlhView || "Product"
    };
  }

  function wishlistContainsVariant(sdk, variantId) {
    if (!sdk || typeof sdk.GetWishListItems !== "function") return false;

    try {
      var items = sdk.GetWishListItems() || [];

      return items.some(function (item) {
        return String(item.ProductVariantId) === String(variantId);
      });
    } catch (error) {
      debug("wishlist items read error", error);
      return false;
    }
  }

  function cleanupWishlistButtons(button) {
    if (!button) return;

    var fallback = button.querySelector("[data-wishlist-fallback]");
    var nativeButtons = Array.prototype.slice.call(button.querySelectorAll("button, a")).filter(function (element) {
      return !element.closest("[data-wishlist-fallback]");
    });

    if (fallback && nativeButtons.length) {
      fallback.remove();
    }

    var containers = Array.prototype.slice.call(button.querySelectorAll("#wishlisthero-product-page-button-container, .wishlisthero-product-page-button-container"));
    var seenNative = false;

    containers.forEach(function (container) {
      if (container.hasAttribute("data-wishlist-fallback")) return;

      if (seenNative) {
        container.remove();
        return;
      }

      seenNative = true;
    });
  }

  function renderWishlistFallbackButton(section) {
    var button = section.querySelector("#wishlist-hero-product-page-button");
    var sdk = window.WishListHero_SDK || window.WishlistHero_SDK;

    cleanupWishlistButtons(button);

    if (!button || !sdk || button.querySelector("button, a")) return;
    if (typeof sdk.AddWishListItem !== "function" || typeof sdk.DeleteWishListItem !== "function") return;

    var productInfo = wishlistProductInfo(button);
    var isAdded = wishlistContainsVariant(sdk, productInfo.ProductVariantId);
    var container = document.createElement("div");
    var fallbackButton = document.createElement("button");

    container.id = "wishlisthero-product-page-button-container";
    container.setAttribute("data-wishlist-fallback", "");
    fallbackButton.type = "button";
    fallbackButton.className = "btn btn--medium btn--full";
    fallbackButton.innerHTML = '<svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"></path></svg> <span data-wishlist-fallback-text></span>';
    container.appendChild(fallbackButton);
    button.appendChild(container);

    function updateButton() {
      var label = isAdded ? "REMOVE FROM WISHLIST" : "ADD TO WISHLIST";
      var text = fallbackButton.querySelector("[data-wishlist-fallback-text]");

      if (text) text.textContent = label;
      fallbackButton.setAttribute("aria-label", label);
    }

    fallbackButton.addEventListener("click", function () {
      fallbackButton.disabled = true;

      var action = isAdded ? sdk.DeleteWishListItem({
        ProductVariantId: productInfo.ProductVariantId,
        WishlistHash: productInfo.WishlistHash
      }) : sdk.AddWishListItem(productInfo);

      Promise.resolve(action).then(function () {
        isAdded = !isAdded;
        updateButton();
      }).catch(function (error) {
        console.error("[CombinedListings] Wishlist fallback button action failed.", error);
      }).finally(function () {
        fallbackButton.disabled = false;
      });
    });

    button.dataset.wlhInitializedVariantId = button.dataset.wlhVariantId;
    updateButton();
  }

  function scheduleWishlistCleanup(section) {
    [250, 1000, 2500, 5000, 8000].forEach(function (delay) {
      window.setTimeout(function () {
        cleanupWishlistButtons(section.querySelector("#wishlist-hero-product-page-button"));
      }, delay);
    });
  }

  function refreshWishlistButton(section, options) {
    var allowFallback = Boolean(options && options.allowFallback);

    [0, 250, 1000, 2500].forEach(function (delay) {
      window.setTimeout(function () {
        initializeWishlistButton(section);
        cleanupWishlistButtons(section.querySelector("#wishlist-hero-product-page-button"));
      }, delay);
    });

    if (!allowFallback) return;

    [1000, 2500, 4000, 7000].forEach(function (delay) {
      window.setTimeout(function () {
        renderWishlistFallbackButton(section);
        cleanupWishlistButtons(section.querySelector("#wishlist-hero-product-page-button"));
      }, delay);
    });
  }

  function syncCombinedListingAvailability(section) {
    Array.prototype.slice.call(section.querySelectorAll("[data-option-value-id][data-product-url]")).forEach(function (element) {
      var productUrl = element.getAttribute(urlAttribute);
      if (!productUrl) return;

      var isAvailable = element.getAttribute("data-option-value-available") !== "false";
      var button = element.matches("[data-button]") ? element : null;

      if (!button && element.tagName === "OPTION") {
        var optionHandle = element.getAttribute("data-value-handle");
        button = optionHandle ? section.querySelector('[data-button][data-option-handle="' + optionHandle + '"]') : null;
      }

      if (button) {
        button.classList.toggle("disabled", !isAvailable);

        if (isAvailable) {
          button.removeAttribute("disabled");
          button.removeAttribute("aria-disabled");
        } else {
          button.setAttribute("aria-disabled", "true");
        }
      }

      if (element.tagName === "OPTION" && isAvailable) {
        element.disabled = false;
      }
    });
  }

  function syncCombinedListingOptionPrices(section) {
    Array.prototype.slice.call(section.querySelectorAll("[data-combined-listings-prices] [data-combined-listings-price-url]")).forEach(function (button) {
      var productUrl = button.getAttribute("data-combined-listings-price-url");
      var variantId = button.getAttribute("data-combined-listings-price-variant-id");

      if (!productUrl) return;

      fetchProduct(productUrl).then(function (product) {
        var variant = selectedProductVariant(product, variantId);
        renderOptionPrice(button, variant);
      }).catch(function (error) {
        debug("option price fetch error", {
          productUrl: productUrl,
          variantId: variantId,
          error: error
        });
      });
    });
  }

  function revealLoadedImages(section) {
    Array.prototype.slice.call(section.querySelectorAll(".image__img")).forEach(function (image) {
      var wrapper = image.closest(".image");
      if (wrapper) {
        wrapper.classList.add("loaded");
      }
    });
  }

  function afterSectionReady(section, options) {
    var shouldRefreshWishlist = Boolean(options && options.refreshWishlist);

    syncCombinedListingAvailability(section);
    syncCombinedListingOptionPrices(section);
    revealLoadedImages(section);

    if (shouldRefreshWishlist) {
      refreshWishlistButton(section, {
        allowFallback: Boolean(options && options.allowWishlistFallback)
      });
    } else {
      scheduleWishlistCleanup(section);
    }

    window.setTimeout(function () {
      syncCombinedListingAvailability(section);
      syncCombinedListingOptionPrices(section);
      revealLoadedImages(section);
      scheduleWishlistCleanup(section);
    }, 0);
  }

  function replaceProductSection(currentSection, responseText, historyUrl) {
    var doc = new DOMParser().parseFromString(responseText, "text/html");
    var sectionId = currentSection.dataset.sectionId;
    var nextSection = doc.querySelector(sectionSelector + "[data-section-id='" + sectionId + "']") || doc.querySelector(sectionSelector);

    if (!nextSection) {
      throw new Error("Fetched product section was not found in the section response.");
    }

    unloadThemeSection(currentSection);
    currentSection.replaceWith(nextSection);
    loadThemeSection(nextSection);
    afterSectionReady(nextSection, {
      refreshWishlist: true,
      allowWishlistFallback: true
    });
    refreshPaymentButtons();

    window.history.replaceState({ path: historyUrl }, "", historyUrl);
    document.dispatchEvent(new CustomEvent("combined-listings:section-rendered", {
      detail: {
        sectionId: sectionId,
        productUrl: nextSection.dataset.productUrl,
        optionValueIds: selectedOptionValueIds(nextSection)
      }
    }));
  }

  function renderSelectedProduct(section, select) {
    if (isRendering) return;

    var optionValueIds = selectedOptionValueIds(section);
    var newProductUrl = targetProductUrl(section, select);
    var currentProductUrl = section.dataset.productUrl || window.location.pathname;
    var currentPath = normalizePath(currentProductUrl);
    var nextPath = normalizePath(newProductUrl);

    debug("selected option values", selectedOptions(section));
    debug("option_value_id", optionValueIds);
    debug("old product URL", currentProductUrl);
    debug("new product URL", newProductUrl);

    if (!newProductUrl || nextPath === currentPath) {
      return;
    }

    if (!optionValueIds.length) {
      console.error("[CombinedListings] Shopify option_value.id is missing. Native Combined Listings section swap was not run.");
      return;
    }

    var sectionId = section.dataset.sectionId;
    var fetchUrl = buildFetchUrl(newProductUrl, sectionId, optionValueIds);
    var historyUrl = buildHistoryUrl(newProductUrl, optionValueIds);

    debug("fetched section URL", fetchUrl.toString());
    isRendering = true;

    fetch(fetchUrl.toString(), {
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
    }).then(function (response) {
      if (!response.ok) throw new Error("Section fetch failed with status " + response.status);
      return response.text();
    }).then(function (html) {
      replaceProductSection(section, html, historyUrl);
    }).catch(function (error) {
      console.error("[CombinedListings] Unable to render selected product without a full page reload.", error);
    }).finally(function () {
      isRendering = false;
    });
  }

  function handleOptionChange(event) {
    var select = event.target && event.target.closest(optionSelector);
    if (!select) return;

    var section = select.closest(sectionSelector);
    if (!section) return;

    renderSelectedProduct(section, select);
  }

  function handleOptionButtonClick(event) {
    var button = event.target && event.target.closest("[data-button][data-option-value-id]");
    if (!button) return;

    var section = button.closest(sectionSelector);
    if (!section) return;

    var optionGroup = button.closest("[data-option-buttons]");
    var select = optionGroup && optionGroup.querySelector(optionSelector);
    if (!select) return;

    window.setTimeout(function () {
      renderSelectedProduct(section, select);
    }, 0);
  }

  function renderParentProductSelections() {
    Array.prototype.slice.call(document.querySelectorAll(sectionSelector)).forEach(function (section) {
      var selected = selectedOptions(section).find(function (item) {
        return item.productUrl && normalizePath(item.productUrl) !== normalizePath(section.dataset.productUrl || window.location.pathname);
      });

      if (selected) {
        renderSelectedProduct(section, selected.select);
      }
    });
  }

  document.addEventListener("change", handleOptionChange);
  document.addEventListener("click", handleOptionButtonClick);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      afterSectionReady(document);
      renderParentProductSelections();
    });
  } else {
    afterSectionReady(document);
    renderParentProductSelections();
  }

  document.addEventListener("submit", function (event) {
    var form = event.target && event.target.closest("[data-product-form]");
    if (!form) return;

    var idInput = form.querySelector("[name='id']");
    debug("active variant id before add to cart", idInput && idInput.value);
  }, true);
})();
